module.exports = __webpack_public_path__ + "img/btn_auto_spin_on.9212df15.png";